<template src="./ConnectGHTKComponent.html"></template>
<script>
import IconHome from "@/components/icons/IconHome.vue";
import BreadcrumbComponent from "@/components/breadcrumb/BreadcrumbComponent.vue";
import InputTextNormal from "@/components/inputs/input-text/normal/InputTextNormal.vue";
import SelectNormal from "@/components/inputs/select/normal/SelectNormal.vue";
import ButtonSearchComponent from "@/components/buttons/button-search/ButtonSearchComponent.vue";
import {useAccountStore} from "@/stores/account.js";
import {AppConstant} from "@/supports/app.constant";
import {ref, computed, onMounted, reactive, nextTick, watch} from "vue";
import CommonService from "@/services/common.service.ts";
import LabelPriority from "@/components/labels/label-priority/LabelPriority.vue";
import LabelStatus from "@/components/labels/label-status/LabelStatus.vue";
import IconEye from "@/components/icons/IconEye.vue";
import ButtonAddComponent from "@/components/buttons/button-add/ButtonAddComponent.vue";
import InputTextareaNormal from "@/components/inputs/input-textarea/normal/InputTextareaNormal.vue";
import {useStore} from "@/stores/store.js";
import InputDateTimeNormal from "@/components/inputs/input-datetime/normal/InputDateTimeNormal.vue";
import {ErrorText} from "@/supports/error-message.constant.js";
import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import ModalCalendarComponent from "@/components/modals/modal-calendar/ModalCalendarComponent.vue";
import SelectCustom from "@/components/inputs/select/custom/SelectCustom.vue";
import {useGHTKStore} from "@/stores/syncGHTK.js";
import ErrorMessageService from "@/services/error-message.service.js";
import {useRoute, useRouter} from "vue-router";
import router from "@/router/index.js";
export default {
  name: 'ConnectGHTKComponent',
  components: {
    SelectCustom,
    ModalCalendarComponent,
    InputDateTimeNormal,
    InputTextareaNormal,
    ButtonAddComponent,
    IconEye,
    LabelStatus,
    VueDatePicker,
    LabelPriority, ButtonSearchComponent, SelectNormal, InputTextNormal, BreadcrumbComponent, IconHome
  },
  setup() {
    const errors = ref(true)
    const errorMessage = ref([])
    const mode = ref('create')
    const labelButtonSetting = ref('Xác thực liên kết')
    const usingWarehouse = ref(null)
    const dataConnectGHTK = ref({
      store_id: {
        id: 'store_id',
        label: 'Cửa hàng',
        placeholder: 'Cửa hàng',
        value: '',
        error: '',
        isError: false,
        required: true,
        options: [],
        disabled: false
      },
      token_name: {
        id: 'token_name',
        label: 'Tên Token',
        placeholder: 'Tên Token',
        value: '',
        error: '',
        isError: false,
        required: true,
        disabled: false
      },
      token: {
        id: 'token',
        label: 'Token',
        placeholder: 'Token',
        value: '',
        error: '',
        isError: false,
        required: true,
        disabled: false
      },
      shop_code: {
        id: 'shop_code',
        label: 'Mã cửa hàng',
        placeholder: 'Mã cửa hàng',
        value: '',
        error: '',
        isError: false,
        required: true,
        disabled: false
      },
      expiration_date: {
        id: 'expiration_date',
        label: 'Ngày hết hạn',
        placeholder: 'Ngày hết hạn',
        value: '',
        error: '',
        isError: false,
        required: true,
        options: AppConstant.GHTK_EXPIRATION_DATE_TOKEN,
        disabled: false
      },
    })
    const syncDetail = ref({})
    const sync_id = ref(null)
    const ghtkExpirationDateSelected = ref(null)
    const inputExpirationDate = ref(false)
    const date = ref(new Date())
    const showCalendar = ref(false)
    const accountStore = useAccountStore()
    const storeCompStore = useStore()
    const syncGHTKStore = useGHTKStore()
    const route = useRoute()
    const router = useRouter()
    const stateModal = reactive({
      modalCalendar: null,
    })

    watch(() => ghtkExpirationDateSelected.value, (newValue) => {
      if (newValue) {
        inputExpirationDate.value = true
      }
    });

    onMounted(() => {
      stateModal.modalCalendar = new bootstrap.Modal('#modalCalendar', {})
      mode.value = route.params.mode;
      if (storeCompStore.stores.length === 0) {
        getListStores()
      } else {
        storeCompStore.stores.forEach((item) => {
          dataConnectGHTK.value.store_id.options.push({
            name: item.name,
            value: item.id
          })
        })
      }
      if(mode.value === 'detail') {
        sync_id.value =  route.params.id;
        getSyncGHTKDetail();
        labelButtonSetting.value = 'Quay lại'
      }
    });


    watch(() => syncGHTKStore.syncGHTK, (newSync) => {
      syncDetail.value = newSync
      dataConnectGHTK.value.store_id.value = newSync.store?.id;
      dataConnectGHTK.value.store_id.disabled = true;
      dataConnectGHTK.value.token.value = newSync.token;
      dataConnectGHTK.value.token.disabled = true;
      dataConnectGHTK.value.token_name.value = newSync.token_name;
      dataConnectGHTK.value.token_name.disabled = true;
      dataConnectGHTK.value.expiration_date.value = newSync.expired_at;
      dataConnectGHTK.value.shop_code.value = newSync.shop_code;
      dataConnectGHTK.value.shop_code.disabled = true;
    });

    async function getListStores() {
      const params = {
        id: accountStore.account.company.id,
        type: 1
      }
      const url = AppConstant.URL_API_LOCAL + 'api/v1/stores/list-stores';
      await storeCompStore.getListStores(url, params);
    }

    function validateForm(value, name) {
      if (name === 'store_id') {
        dataConnectGHTK.value.store_id.isError = false;
        dataConnectGHTK.value.store_id.error = ''
        errors.value = false
        if (!value) {
          dataConnectGHTK.value.store_id.isError = true;
          dataConnectGHTK.value.store_id.error = ErrorText.REQUIRED(dataConnectGHTK.value.store_id.label);
          errors.value = true
        }
      }
      if (name === 'token_name') {
        dataConnectGHTK.value.token_name.isError = false;
        dataConnectGHTK.value.token_name.error = ''
        errors.value = false
        if (!value) {
          dataConnectGHTK.value.token_name.isError = true;
          dataConnectGHTK.value.token_name.error = ErrorText.REQUIRED(dataConnectGHTK.value.token_name.label);
          errors.value = true
        }
      }
      if (name === 'token') {
        dataConnectGHTK.value.token.isError = false;
        dataConnectGHTK.value.token.error = ''
        errors.value = false
        if (!value) {
          dataConnectGHTK.value.token.isError = true;
          dataConnectGHTK.value.token.error = ErrorText.REQUIRED(dataConnectGHTK.value.token.label);
          errors.value = true
        }
      }
      if (name === 'expiration_date') {
        dataConnectGHTK.value.expiration_date.isError = false;
        dataConnectGHTK.value.expiration_date.error = ''
        errors.value = false
        if (!value) {
          dataConnectGHTK.value.expiration_date.isError = true;
          dataConnectGHTK.value.expiration_date.error = ErrorText.REQUIRED(dataConnectGHTK.value.expiration_date.label);
          errors.value = true
        }
      }
      if (name === 'shop_code') {
        dataConnectGHTK.value.shop_code.isError = false;
        dataConnectGHTK.value.shop_code.error = ''
        errors.value = false
        if (!value) {
          dataConnectGHTK.value.shop_code.isError = true;
          dataConnectGHTK.value.shop_code.error = ErrorText.REQUIRED(dataConnectGHTK.value.shop_code.label);
          errors.value = true
        }
        if (!errors.value && !value) {
          dataConnectGHTK.value.shop_code.isError = true;
          dataConnectGHTK.value.shop_code.error = ErrorText.MAX_LENGTH(dataConnectGHTK.value.shop_code.label, AppConstant.MAX_LENGTH_SHOP_CODE_GHTK);
          errors.value = true
        }
      }
    }

    function onChange(value, name) {
      dataConnectGHTK.value[name].value = value;
      if (name === 'expiration_date' && value === AppConstant.GHTK_EXPIRATION_DATE_TOKEN_OPTION_8) {
        showCalendar.value = true
        stateModal.modalCalendar.show()
      }
    }

    function actionDateSelected(date) {
      stateModal.modalCalendar.hide()
      ghtkExpirationDateSelected.value = CommonService.formatDate(date)
      AppConstant.GHTK_EXPIRATION_DATE_TOKEN.push({
        value: 9,
        name: ghtkExpirationDateSelected.value,
        style: {
          hidden: true
        }
      })
      dataConnectGHTK.value.expiration_date.value = 9
    }

    async function createOrUpdateGHTK() {
      errorMessage.value = []
      for (const item in dataConnectGHTK.value) {
        validateForm(dataConnectGHTK.value[item].value, item)
      }
      if(checkSubmitActive.value) {
        const params = {
          m_company_id: accountStore.account.company.id,
          store_id: dataConnectGHTK.value.store_id.value,
          token: dataConnectGHTK.value.token.value,
          token_name: dataConnectGHTK.value.token_name.value,
          shop_code: dataConnectGHTK.value.shop_code.value,
          expiration_date: dataConnectGHTK.value.expiration_date.value === 8 ? ghtkExpirationDateSelected.value : dataConnectGHTK.value.expiration_date.value,
        }
        const url = AppConstant.URL_API_LOCAL + 'api/v1/third-party/ghtk/authenticate-ghtk';
        const res = await syncGHTKStore.authenticateGHTK(url, params)
        const errorMessageRes = await ErrorMessageService.getErrorMessage(res)
        if(errorMessageRes !== undefined && errorMessageRes.length > 0) {
          errorMessage.value = typeof errorMessageRes === 'string' ? [errorMessageRes] : errorMessageRes;
        } else {
          await CommonService.showAlertPopup({
            title: res?.message,
            icon: "success",
            showConfirmButton: false,
            timer: 1000,
            width: '800px'
          });
        }
      }
    }
    const checkSubmitActive = computed(() => {
      return !errors.value;
    })

    function redirectToList() {
      router.push('/third-party/ghtk')
    }

    async function getSyncGHTKDetail() {
      const params = {
        company_id: accountStore.account.company.id,
        sync_id: sync_id.value,
      }
      const url = AppConstant.URL_API_LOCAL + 'api/v1/third-party/ghtk/detail';
      await syncGHTKStore.getSyncGHTKDetail(url, params);
    }

    return {
      mode,
      usingWarehouse,
      labelButtonSetting,
      dataConnectGHTK,
      date,
      showCalendar,
      ghtkExpirationDateSelected,
      inputExpirationDate,
      createOrUpdateGHTK,
      redirectToList,
      actionDateSelected,
      CommonService,
      errors,
      onChange,
      validateForm,
      errorMessage,
      checkSubmitActive
    }
  }
}
</script>
<style lang="scss">
.dashboard-page {
  margin-top: 80px;
  margin-left: 265px;
  height: 100%;
  .title-page {
    padding: 15px 30px;
    background-color: #fff;
  }
  .container-fluid {
    padding-top: 30px;
    .card {
      margin-bottom: 30px;
      letter-spacing: .5px;
      box-shadow: 0 9px 20px rgba(46,35,94,.07);
      .card-body {
        padding: 30px;
        border-radius: 15px;
        background-color: #ffffff;
        #expiration_date {
          option {
            &:nth-child(8) {
              display: none;
            }
          }
        }
      }
    }
  }
}
</style>
